/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type CompareMode = 'strict' | 'equal';

export class CompareModes {
  static readonly STRICT: CompareMode = 'strict';
  static readonly EQUAL: CompareMode = 'equal';
}
